import { Grid } from "@mui/material";
import CardActions from "src/pages/sistema/components/CardActions";
import { FieldView, SectionBox } from "src/pages/sistema/components/FieldView";
import { dateFormatter } from "src/utils/formatters";
import { OperacionAFOPUFields } from '../types/fields';
import { OperacionAFOPU } from "../types/types";

type SeccionAFOPUDatosOperacionProps = {
  operacion?: OperacionAFOPU;
}

const SeccionAFOPUDatosOperacion = ({ operacion }: SeccionAFOPUDatosOperacionProps) => {
  return (
    <CardActions title='Datos Operación' icon='mdi:briefcase-outline' colapsable>
      {operacion && (
        <SectionBox>
          <Grid item xs={12} md={2}>
            <FieldView label='País' value={operacion[OperacionAFOPUFields.NombrePais]} />
          </Grid>
          <Grid item xs={12} md={2}>
            <FieldView
              label='Usuario Alta'
              value={`${operacion[OperacionAFOPUFields.NombreUsuarioAlta]} ${operacion[OperacionAFOPUFields.ApellidoUsuarioAlta]}`}
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <FieldView label='Unidad de Negocio' value={operacion[OperacionAFOPUFields.DescUnidadNegocio]} />
          </Grid>
          <Grid item xs={12} md={2}>
            <FieldView label='Equipo Comercial' value={operacion[OperacionAFOPUFields.DescSectorComercial]} />
          </Grid>
          <Grid item xs={12} md={2}>
            <FieldView
              label='Fecha de Solicitud'
              value={operacion[OperacionAFOPUFields.FechaSolicitud]
                ? dateFormatter.toShortDate(operacion[OperacionAFOPUFields.FechaSolicitud])
                : undefined}
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <FieldView
              label='Fecha de Vencimiento'
              value={operacion[OperacionAFOPUFields.FechaVencimiento]
                ? dateFormatter.toShortDate(operacion[OperacionAFOPUFields.FechaVencimiento])
                : undefined}
            />
          </Grid>
          <Grid item xs={12}>
            <FieldView label='Observaciones' value={operacion[OperacionAFOPUFields.Observaciones]} />
          </Grid>
        </SectionBox>
      )}
    </CardActions>
  );
}

export default SeccionAFOPUDatosOperacion;